<template>
  <div id="app2">
    <el-container class="container">
      <!-- 侧边栏 -->

      <!-- <componentHeader-nav></componentHeader-nav> -->
      <!-- 主体区域：头部和主体部分 -->
      <el-container class="main">
        <!-- 主体区域 -->
        <el-main>
          <!-- <p style="color: white;font-size: 20px;">{{$store.state.user.isFixed}}</p> -->
          <!-- <div  :class="['notFixed', $store.state.user.isFixed ? 'isFixed' : '' ]" style="z-index: 999;"> -->
            <!-- <HeaderNav :windowWidth="windowWidth" /> -->
          <!-- </div> -->
            <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script type="text/javascript">
document.body.addEventListener(
  'touchmove',
  function (e) {
    e.preventDefault()
  },
  { passive: false }
)

</script>
<script>
// import HeaderNav from '@/components/HeaderNav'
// import ComponentHeaderNav from './components/ComponentHeaderNav.vue'
export default {
  name: 'ADmin',
  // components: { HeaderNav },
  data () {
    return {
    }
  },
  watch: {

  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      console.log(from.path, to.fullPath, '这是主体页面需要执行的')
      vm.$store.commit('menu/SET_NEV', to.fullPath)
      // vm就是this
      // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例 ; vm就相当于this!!!!
      // vm.formUrl = from.path
      if (to.fullPath === '/dashBoard') {
        vm.$store.commit('user/NAV_IBFO', true)
      }
    })
  },
  mounted () {
    // this.topNoPullDown()
  },
  methods: {
    // 当页面到达顶端的时候阻止手动下拉，用于隐藏微信h5下拉展示网页来源
    topNoPullDown () {
      const overscroll = function (el) {
        el.addEventListener('touchstart', function () {
          const top = el.scrollTop
          const totalScroll = el.scrollHeight
          const currentScroll = top + el.offsetHeight
          if (top === 0) {
            el.scrollTop = 1
          } else if (currentScroll === totalScroll) {
            el.scrollTop = top - 1
          }
        })
        el.addEventListener('touchmove', function (evt) {
          if (el.offsetHeight < el.scrollHeight) evt._isScroller = true
        })
      }
      overscroll(document.querySelector('#app'))
      document.body.addEventListener(
        'touchmove',
        function (evt) {
          console.log(evt._isScroller)
          if (!evt._isScroller) {
            evt.preventDefault()
          }
        },
        { passive: false }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
// #app2{
//   overflow-y: scroll;
//   overflow-x: hidden;
//   -webkit-overflow-scrolling: touch;
//   height: 100vh;
//   z-index: 200
// }
// 主体
.el-main {
  background-color: #000000;
  padding: 0rem !important;
}
.notFixed{
  position: sticky;
}
.isFixed{
  position: fixed;
}
</style>
